import { useLazyChangeApplicationStateQuery } from "@/modules/application/services";
import { OperationNextState } from "@/shared/common/enums";
import { useNotify } from "@/shared/hooks";
import { Modal } from "@ab.uitools/ui-library/components/Modal";
import { Text } from "@ab.uitools/ui-library/components/Text";
import { useTranslation } from "react-i18next";

interface Props {
  onConfirm: () => void;
  onClose: () => void;
  applicationId: string;
  applicationType: string;
  isOpen: boolean;
}

export const SendToEditModal = ({
  isOpen,
  onClose,
  onConfirm,
  applicationId,
  applicationType,
}: Props) => {
  const { t } = useTranslation();
  const { showSuccessSnackbar, showErrorSnackbar } = useNotify();
  const [sendToEdit] = useLazyChangeApplicationStateQuery();

  const handleSendToEdit = () => {
    sendToEdit({
      id: applicationId,
      data: {
        applicationType,
        nextState: OperationNextState.SendToEdit,
      },
    })
      .unwrap()
      .then(() => {
        showSuccessSnackbar(t("alerts.applicationHasBeenSuccessfullySendToEdit"));
        onConfirm();
        onClose();
      })
      .catch((error) => {
        showErrorSnackbar(error);
        onClose();
      });
  };

  return (
    <Modal
      onSubmit={handleSendToEdit}
      titleProps={{
        title: t("application.sendToEdit.title"),
        size: "large",
      }}
      isOpen={isOpen}
      onClose={onClose}
      buttonProps={{
        confirm: {
          buttonText: t("general.confirm"),
          buttonActionType: "submit",
        },
        cancel: {
          buttonText: t("general.cancel")
        },
      }}
    >
      <div>
        <Text>{t("application.sendToEdit.description")}</Text>
      </div>
    </Modal>
  );
};
